import { jsx as l } from "react/jsx-runtime";
const i = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m6.956 1.508-4.8.623-.67 4.847 7.574 7.575 5.475-5.46-7.579-7.585Zm-2.062 3.96a.77.77 0 1 1 0-1.54.77.77 0 0 1 0 1.54Z"
      }
    )
  }
);
export {
  i as PricingFilled
};
